import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';
import screenshotShelfDe from '../assets/screenshots/screenshot-shelf-de.png';
import screenshotShelfEn from '../assets/screenshots/screenshot-shelf-en.png';
import screenshotDetailDe from '../assets/screenshots/screenshot-detail-de.png';
import screenshotDetailEn from '../assets/screenshots/screenshot-detail-en.png';
import screenshotWishlistDe from '../assets/screenshots/screenshot-wishlist-de.png';
import screenshotWishlistEn from '../assets/screenshots/screenshot-wishlist-en.png';
import screenshotRegisterDe from '../assets/screenshots/screenshot-register-de.png';
import screenshotRegisterEn from '../assets/screenshots/screenshot-register-en.png';
import screenshotAddMangaDe from '../assets/screenshots/screenshot-add-manga-de.png';
import screenshotAddMangaEn from '../assets/screenshots/screenshot-add-manga-en.png';
import screenshotNotificationsDe from '../assets/screenshots/screenshot-notifications-de.png';
import screenshotNotificationsEn from '../assets/screenshots/screenshot-notifications-en.png';
import screenshotProfileDe from '../assets/screenshots/screenshot-profile-de.png';
import screenshotProfileEn from '../assets/screenshots/screenshot-profile-en.png';

function Docs({ loggedIn, username }) {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language?.startsWith('en');
  const screenshotShelf = isEn ? screenshotShelfEn : screenshotShelfDe;
  const screenshotDetail = isEn ? screenshotDetailEn : screenshotDetailDe;
  const screenshotWishlist = isEn ? screenshotWishlistEn : screenshotWishlistDe;
  const screenshotRegister = isEn ? screenshotRegisterEn : screenshotRegisterDe;
  const screenshotAddManga = isEn ? screenshotAddMangaEn : screenshotAddMangaDe;
  const screenshotNotifications = isEn ? screenshotNotificationsEn : screenshotNotificationsDe;
  const screenshotProfile = isEn ? screenshotProfileEn : screenshotProfileDe;
  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('docs.title')}</h1>
          <div className={styles.content}>
            <h2>{t('docs.gettingStarted')}</h2>
            <p>{t('docs.welcome')}</p>

            <h3>{t('docs.step1Title')}</h3>
            <p>{t('docs.step1Text')}</p>
            <img src={screenshotRegister} alt="MangaShelf registration form" className={styles.docsScreenshot} loading="lazy" />

            <h3>{t('docs.step2Title')}</h3>
            <p>
              <Trans i18nKey="docs.step2Text" components={[<strong key="0" />, <strong key="1" />, <strong key="2" />]} />
            </p>
            <img src={screenshotAddManga} alt="Adding a manga to your collection by title search" className={styles.docsScreenshot} loading="lazy" />

            <h3>{t('docs.step3Title')}</h3>
            <p>{t('docs.step3Text')}</p>
            <img src={screenshotDetail} alt="Managing a series' collection and reading progress" className={styles.docsScreenshot} loading="lazy" />

            <h2>{t('docs.featuresOverview')}</h2>

            <h3>{t('docs.shelfTitle')}</h3>
            <p>{t('docs.shelfText')}</p>
            <img src={screenshotShelf} alt="MangaShelf shelf overview" className={styles.docsScreenshot} loading="lazy" />

            <h3>{t('docs.detailTitle')}</h3>
            <p>
              <Trans i18nKey="docs.detailText" components={[<strong key="0" />, <em key="1" />, <em key="2" />, <em key="3" />]} />
            </p>

            <h3>{t('docs.wishlistTitle')}</h3>
            <p>{t('docs.wishlistText')}</p>
            <img src={screenshotWishlist} alt="MangaShelf wishlist with shop links" className={styles.docsScreenshot} loading="lazy" />

            <h3>{t('docs.notifTitle')}</h3>
            <p>{t('docs.notifText')}</p>
            <img src={screenshotNotifications} alt="Per-series notification settings in MangaShelf" className={styles.docsScreenshot} loading="lazy" />

            <h3>{t('docs.discoverFriendsTitle')}</h3>
            <p>{t('docs.discoverFriendsText')}</p>

            <h3>{t('docs.profileStatsTitle')}</h3>
            <p>{t('docs.profileStatsText')}</p>
            <img src={screenshotProfile} alt="Profile statistics in MangaShelf" className={styles.docsScreenshot} loading="lazy" />

            <h2>{t('docs.questionsTitle')}</h2>
            <p>
              <Trans
                i18nKey="docs.questionsText"
                components={[
                  // eslint-disable-next-line jsx-a11y/anchor-has-content -- Inhalt kommt zur Laufzeit aus der Übersetzung
                  <a key="0" href="https://github.com/KilianJATO/MangaOrganisation" target="_blank" rel="noopener noreferrer" />,
                  <Link key="1" to="/contact" />,
                ]}
              />
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Docs;
